import { IUnmanagedBusiness } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  ExistsAggregateBusinessAndBaseBusinessAllOfResult,
  ExistsAggregateBusinessAndBaseBusinessParameters,
} from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 集計取引と関連取引の重複を確認するユースケース
 * （内示・販売実績の場合に使用）
 */
export class CheckDuplicateAggregateBusinessAndBusinessUseCase {
  /**
   * 集計取引の重複を確認する
   * @param repository - 取引情報のリポジトリ
   * @param business - 取引情報
   * @param limit - 取得する最大数
   * @returns 重複している場合は重複している取引情報のIDを返す
   */
  static async execute(
    repository: IAggregateBusinessRepository,
    business: IUnmanagedBusiness,
    limit = 100
  ): Promise<INetworkResult<ExistsAggregateBusinessAndBaseBusinessAllOfResult, Error>> {
    try {
      if (business.salesDestinationNumber === undefined || business.customerNumber === undefined) {
        throw new Error('取引情報が不足しています');
      }
      const parameters: ExistsAggregateBusinessAndBaseBusinessParameters = {
        warehouseNumber: business.warehouseNumber,
        supplierNumber: business.supplierNumber,
        businessNumber: business.businessNumber,
        package: Number(business.package),
        customerNumber: business.customerNumber,
        salesDestinationNumber: business.salesDestinationNumber,
      };
      const result = await repository.checkDuplicateAggregateBusinessAndBusiness(parameters, limit);

      if (result.status.type === 'error') {
        return {
          status: {
            type: 'error',
            error: Error('取引情報の作成に失敗しました'),
          },
        };
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取引情報の作成に失敗しました'),
        },
      };
    }
  }
}
